// src/pages/Trend/components/brand/BrandPanelContent.js
import React from 'react';
import PropTypes from 'prop-types';
import {
  Check,
  Info,
  Droplets,
  Heart,
  Wind,
  Sun,
  Sparkles,
  LayoutGrid
} from 'lucide-react';
import { useLanguage } from '../../../../contexts/LanguageContext';
import './BrandPanelContent.css';

const CATEGORY_CONFIG = [
  { id: '', icon: LayoutGrid, labelKey: 'brandPage.categories.all' },
  { id: 'CM01', icon: Droplets, labelKey: 'brandPage.categories.skincare' },
  { id: 'CM02', icon: Heart, labelKey: 'brandPage.categories.bodycare' },
  { id: 'CM03', icon: Wind, labelKey: 'brandPage.categories.haircare' },
  { id: 'CM04', icon: Sun, labelKey: 'brandPage.categories.suncare' },
  { id: 'CM05', icon: Sparkles, labelKey: 'brandPage.categories.cleansing' }
];

const BrandPanelContent = ({ selectedCategory, onCategoryChange }) => {
  const { translate } = useLanguage();

  const handleCategoryClick = (categoryId) => {
    // Find the category name from the id
    const category = CATEGORY_CONFIG.find(c => c.id === categoryId);
    const categoryName = translate(category.labelKey);
    onCategoryChange(categoryName);
  };

  return (
    <div className="brand-panel-content">
      {/* Category Selection */}
      <div className="filter-section">
        <div className="filter-section-header">
          <span className="filter-section-label">
            {translate('brandPage.filters.category') || 'Category'}
          </span>
          <button className="info-button">
            <Info size={14} />
          </button>
        </div>

        <div className="category-radio-group">
          {CATEGORY_CONFIG.map(({ id, icon: Icon, labelKey }) => {
            const isActive = selectedCategory === id;
            return (
              <label
                key={id}
                className={`category-radio-option ${isActive ? 'active' : ''}`}
                data-category={id}
              >
                <input
                  type="radio"
                  name="brand-category"
                  value={id}
                  checked={isActive}
                  onChange={() => handleCategoryClick(id)}
                  className="category-radio-input"
                />
                <div className="category-radio-content">
                  <Icon size={16} className="category-radio-icon" />
                  <span className="category-radio-label">{translate(labelKey)}</span>
                </div>
                {isActive && (
                  <Check size={16} className="category-radio-check" />
                )}
              </label>
            );
          })}
        </div>
      </div>

    </div>
  );
};

BrandPanelContent.propTypes = {
  selectedCategory: PropTypes.string.isRequired,
  onCategoryChange: PropTypes.func.isRequired
};

export default BrandPanelContent;
